const STORAGE_KEY = 'wf-coe-app:scenarios:recent';
const MAX_ITEMS = 8;

export interface RecentScenario {
  fusionId: string;
  name: string;
  folderName?: string;
  /** Epoch-ms of last view, used to surface the newest entries first. */
  viewedAt: number;
}

function read(): RecentScenario[] {
  if (typeof window === 'undefined') return [];
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter(
      (e): e is RecentScenario =>
        e &&
        typeof e === 'object' &&
        typeof (e as RecentScenario).fusionId === 'string' &&
        typeof (e as RecentScenario).name === 'string' &&
        typeof (e as RecentScenario).viewedAt === 'number',
    );
  } catch {
    return [];
  }
}

function write(entries: RecentScenario[]): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(entries));
  } catch {
    /* incognito + storage-disabled — silently skip; recents are best-effort */
  }
}

export function pushRecentScenario(entry: {
  fusionId: string;
  name: string;
  folderName?: string;
}): void {
  if (!entry.fusionId || !entry.name) return;
  const now = Date.now();
  const without = read().filter((e) => e.fusionId !== entry.fusionId);
  const next: RecentScenario[] = [
    { fusionId: entry.fusionId, name: entry.name, folderName: entry.folderName, viewedAt: now },
    ...without,
  ].slice(0, MAX_ITEMS);
  write(next);
}

export function getRecentScenarios(): ReadonlyArray<RecentScenario> {
  return read().sort((a, b) => b.viewedAt - a.viewedAt);
}

export function clearRecentScenarios(): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* noop */
  }
}
